import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { todaysPicksTerms } from '../../../constants/suggestedAgents';

const getBarColorClass = (activeLevel, barLevel) => {
    const levels = { low: 0, medium: 1, high: 2 };
    const activeIndex = levels[activeLevel];
    const barIndex = levels[barLevel];
    
    if (barIndex > activeIndex) return null;
    
    const distance = activeIndex - barIndex;
    
    if (distance === 0) return 'likelihood-chart-bar--brand';
    if (distance === 1) return 'likelihood-chart-bar--brand-light';
    return 'likelihood-chart-bar--brand-alt-light';
};

export const LikelihoodChart = ({ likelihood }) => {
    const activeLevel = likelihood?.toLowerCase();

    return (
        <div>
            <div className="helix-text-gray-500 likelihood-chart-title m-0">
                {todaysPicksTerms.likelihoodChartTitle}
            </div>
            <div className="helix-d-flex helix-align--end likelihood-chart-container">
                {['low', 'medium', 'high'].map((level) => {
                    const colorClass = getBarColorClass(activeLevel, level);
                    const isCurrentLevel = level === activeLevel;
                    
                    return (
                        <div 
                            key={level} 
                            className="helix-d-flex helix-flex--column helix-align--center helix-flex-1"
                        >
                            <div 
                                className={clsx(
                                    'likelihood-chart-bar',
                                    `likelihood-chart-bar--${level}`,
                                    colorClass ?? 'likelihood-chart-bar--inactive'
                                )}
                            />
                            <span 
                                className={clsx(
                                    'helix-mt-1 likelihood-chart-label',
                                    isCurrentLevel 
                                        ? 'helix-text-gray-900' 
                                        : 'helix-text-gray-400'
                                )}
                            >
                                {todaysPicksTerms[level]}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

LikelihoodChart.propTypes = {
    likelihood: PropTypes.oneOf(['low', 'medium', 'high']).isRequired,
};

export default LikelihoodChart;
